import type { SVGProps } from "react";
export interface SnowflakeIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function SnowflakeIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: SnowflakeIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M10.08 21.465a1.126 1.126 0 0 1-1.16-1.93zm1.479-3.5c.328-.14.708-.116 1.02.07l2.5 1.5a1.124 1.124 0 0 1-1.157 1.93L12 20.312l-1.92 1.153-.58-.965-.58-.964 2.501-1.5.138-.07Zm-4.786.47a1.125 1.125 0 0 1-2.248-.039zm13.647-5.342a1.125 1.125 0 1 1 1.059 1.984l-2.042 1.09.04 2.229-.005.114a1.125 1.125 0 0 1-2.238.04l-.008-.116-.051-2.915a1.13 1.13 0 0 1 .595-1.01zm-18.36.462c.274-.514.89-.728 1.417-.511l.104.05 2.649 1.414c.372.2.602.59.594 1.013l-.05 2.915-1.124-.021-1.125-.019.038-2.228-2.042-1.091-.098-.059a1.125 1.125 0 0 1-.364-1.463Zm3.57-9.096a1.126 1.126 0 0 1 1.136.99l.009.116.05 2.915c.007.423-.223.814-.595 1.013l-2.65 1.415a1.125 1.125 0 0 1-1.06-1.985l2.042-1.091-.038-2.227.003-.116a1.125 1.125 0 0 1 1.101-1.03Zm12.74.002c.621.01 1.117.523 1.106 1.144l-.04 2.227 2.043 1.09a1.125 1.125 0 1 1-1.06 1.986l-2.65-1.415a1.13 1.13 0 0 1-.594-1.013l.051-2.915.008-.114c.067-.566.554-1 1.136-.99m-4.448-1.926a1.125 1.125 0 0 1 1.157 1.93l-2.5 1.5a1.13 1.13 0 0 1-1.158 0l-2.5-1.5a1.126 1.126 0 0 1 1.158-1.93L12 3.686z"
      />
      <path
        fill={color}
        d="M10.875 22v-8.09l-7.329 4.073a1.124 1.124 0 1 1-1.093-1.966L9.683 12l-7.23-4.015-.098-.062a1.126 1.126 0 0 1 1.089-1.957l.102.052 7.329 4.07V2a1.125 1.125 0 0 1 2.25 0v8.087l7.328-4.07.103-.052a1.126 1.126 0 0 1 .99 2.019l-7.23 4.015 7.23 4.018.098.06a1.126 1.126 0 0 1-1.087 1.957l-.104-.051-7.328-4.072V22a1.125 1.125 0 0 1-2.25 0"
      />
    </svg>
  );
}
